import { render, staticRenderFns } from "./Partie6.vue?vue&type=template&id=59dc95fb&"
import script from "./Partie6.vue?vue&type=script&lang=js&"
export * from "./Partie6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports